import { render } from "./StockImageTag.vue?vue&type=template&id=c6f50260&ts=true"
import script from "./StockImageTag.vue?vue&type=script&lang=ts"
export * from "./StockImageTag.vue?vue&type=script&lang=ts"

import "./StockImageTag.vue?vue&type=style&index=0&id=c6f50260&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__